import React from 'react'
import { Link } from 'react-router-dom';
// Components
import useRippleEffect from '../hooks/useRippleEffect';
// CSS
import '../assets/css/course-card.css';

export default function CourseCard(props) {
  useRippleEffect();

  return (
    <div className="course_card">
      <div className="thumbnail select_n">
        <img src={props.thumbnail} alt="Course Thumbnail" />
      </div>
      <div className="details">
        <Link to="/course/full-stack-web-development" className="title">{props.title}</Link>

        <div className='mentor_details'>
          <div className="d_flex al_center w_100">
            {
              props.mentors.map((mentor, index) => {
                return(
                  <div className="mentor">
                    <div className="image" key={index}>
                      <img src={mentor.mentorImage} alt="Mentor Image" />
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}
